import { Phone, AlertCircle } from "lucide-react";

export default function EmergencyBanner() {
  return (
    <div className="brand-gradient text-white" data-testid="emergency-banner">
      <div className="container-x py-2.5 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[13px]">
        <span className="inline-flex items-center gap-2 font-medium">
          <AlertCircle className="w-4 h-4" strokeWidth={2} />
          Need care immediately?
        </span>
        <a href="tel:+14027611531" className="inline-flex items-center gap-2 font-semibold underline-offset-4 hover:underline" data-testid="emergency-banner-phone">
          <Phone className="w-3.5 h-3.5" /> Call (402) 761-1531 — available 24/7
        </a>
      </div>
    </div>
  );
}
